(function() {
    'use strict'

    Vue.filter('locallyFormatDate', value => value ? moment(String(value)).format('l') : '' );

    Vue.component('overdue-jobs-panel', {
        template: '#v-overdue-jobs-panel',
        data() {
            return {
            };
        },
        methods: {
			onShowTab: function( openning ){
				LocalStorageManager.updateField( 'overdueJobList' );
			},
			showOverdueJobsTab: function() {
				AppTabs.showTab( 'overdue-jobs' );
			},
            snooze: function( numDays, job ) {
                window.ConfirmationModalManager.show({
                    title: "Snooze Job ",
                    message: "Are you sure you want to snooze overdue Job " + job.JobNumber + " for " + numDays + " days?",
                    buttonText: "Snooze",
                    callback: function() {
                        job.SnoozeDate = moment().add(numDays, 'days').format('YYYY-MM-DD');

                        window.ajaxCall({
                            data: {
                                action: 'snooze_job',
                                jobId: job.JobID,
                                snoozeDate: job.SnoozeDate,
                            },
                            onSuccess: function(data){
                                window.broadcastLocalStorageUpdateRequest('overdueJobList');
                            },
                        });
                    },
                });
            },
        },
        computed: {
			overdueJobs: x => store.state.overdueJobList,
            numOverdueJobs: function() {
                return this.overdueJobs != null ? this.overdueJobs.length : '?';
            },
			topFewUnsnoozedOverdueJobs: function() {
                return this.unsnoozedOverdueJobs.slice( 0, 10 );
			},
            numUnsnoozedOverdueJobs: function() {
                return this.unsnoozedOverdueJobs.length;
            },
            unsnoozedOverdueJobs: function() {
                return this.overdueJobs ? this.overdueJobs.filter( job =>
                    new Date( job.SnoozeDate ) == "Invalid Date"
                    || new Date( job.SnoozeDate ) < new Date()
                ) : [];
            }
        }
    });


})();
